import { Card, CardBody, Col } from "reactstrap";
import CardHeaderCommon from "../../../../CommonElements/CommonCardHeader/CardHeaderCommon";
import { LatestSalesHeading } from "../../../../utils/Constant";
import RecentSalesTable from "./RecentSalesTable";

const RecentSales = () => {
  return (
    <Col xl="5" lg="6">
      <Card className="recent-orders">
        <CardHeaderCommon title={LatestSalesHeading} />
        <CardBody className="pt-0">
          <RecentSalesTable />
        </CardBody>
      </Card>
    </Col>
  );
};

export default RecentSales;
